import { queryOptions } from '@tanstack/react-query';
import { loyaltyAPIClient } from '../loyaltyAPIClient';
import { LOYALTY_QUERY_KEYS } from './keys';
import type { GetCustomerBalanceRequest, GetTransactionHistoryRequest, GetLoyaltyPolicyRequest } from './types';

export const LOYALTY_QUERIES = {
  getCustomerBalance: ({ customerId }: GetCustomerBalanceRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getCustomerBalance({ customerId }),
      queryFn: () => {
        return loyaltyAPIClient.getCustomerBalance({ customerId });
      },
    });
  },

  getTransactionHistory: ({ customerId, limit, lastEvaluatedKey }: GetTransactionHistoryRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getTransactionHistory({ customerId, limit, lastEvaluatedKey }),
      queryFn: () => {
        return loyaltyAPIClient.getTransactionHistory({ customerId, limit, lastEvaluatedKey });
      },
    });
  },

  getLoyaltyPolicy: ({ currency }: GetLoyaltyPolicyRequest) => {
    return queryOptions({
      queryKey: LOYALTY_QUERY_KEYS.getLoyaltyPolicy({ currency }),
      queryFn: () => {
        return loyaltyAPIClient.getLoyaltyPolicy({ currency });
      },
    });
  },
};
